import { motion } from "framer-motion";
import Corners from "../wam/Corners";

const BULLETS = [
  "A clear view of your current lead-to-follow-up path",
  "The highest-leverage gap to address first",
  "A practical next-step recommendation for your business",
  "A direct conversation — not a canned demo",
];

export default function ReplayWhy() {
  return (
    <section
      className="relative py-28 md:py-40"
      data-testid="replay-why"
    >
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="mb-10 flex items-center gap-4"
        >
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#F0ECE4]/40">
            [003] —
          </span>
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#C9A84C]">
            MAKE IT SPECIFIC
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="font-display max-w-[1100px]"
          style={{ fontSize: "clamp(32px, 4.6vw, 68px)", lineHeight: 0.98, letterSpacing: "-0.03em" }}
        >
          Your business doesn&rsquo;t need another <span className="text-[#C9A84C]">generic playbook.</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="relative mt-14 border border-[#C9A84C]/25 bg-white/[0.02] p-8 md:p-12"
        >
          <Corners />
          <div className="font-mono text-[10px] tracking-[0.28em] text-[#C9A84C]/70 mb-6">
            ON THE STRATEGY CALL YOU&rsquo;LL LEAVE WITH
          </div>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
            {BULLETS.map((b, i) => (
              <motion.li
                key={b}
                initial={{ opacity: 0, x: -8 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: 0.3 + i * 0.08 }}
                className="flex items-start gap-3 border-t wam-hairline pt-4"
                data-testid={`replay-why-bullet-${i}`}
              >
                <span className="text-[#C9A84C] font-display text-[16px] leading-none mt-[3px]">
                  ✓
                </span>
                <span className="font-body text-[14px] leading-[1.6] text-[#F0ECE4]/85">
                  {b}
                </span>
              </motion.li>
            ))}
          </ul>

          <div className="mt-10 flex flex-wrap items-baseline gap-x-2 gap-y-1 font-mono text-[10px] tracking-[0.28em] text-[#F0ECE4]/50">
            <span>YOUR INVESTMENT TODAY:</span>
            <span className="text-[#C9A84C]">$0</span>
            <span>·</span>
            <span>YOUR NEXT MOVE:</span>
            <span className="text-[#C9A84C]">CLARITY</span>
          </div>

          <a
            href="#book"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="wam-btn-primary mt-8 inline-block text-[12px]"
            data-testid="replay-why-cta"
          >
            Book My Free Strategy Call →
          </a>
        </motion.div>
      </div>
    </section>
  );
}
